export default __webpack_public_path__ + "static/media/Banner4.3fa49275.webp";